/**
 * privacy-policy-hash-nav.js
 * Legends Global — Shopify Plus / Dawn theme
 *
 * Opens any <details class="policy-section"> ancestor when navigating
 * to an anchor link inside it. Handles TOC clicks and all inline
 * cross-reference links automatically.
 *
 * INSTALLATION:
 *   1. Upload this file to the theme's Assets folder.
 *   2. In sections/main-page.liquid, just before {% schema %}:
 *
 *      {% if page.handle contains 'privacy' or page.handle contains 'terms' %}
 *        <script src="{{ 'privacy-policy-hash-nav.js' | asset_url }}" defer></script>
 *      {% endif %}
 */

/**
 * ── TEMPLATE VARIABLES ──────────────────────────────────────────────────────
 * Fill in each value before publishing the Terms of Use page.
 * Keys map to data-tou-var="..." attributes in the ToU HTML.
 * Unused keys are harmless — the substitution only runs when matching
 * elements exist on the page.
 *
 * To update: edit this file in the theme Assets folder and save.
 */
var touVars = {
  LAST_UPDATED: 'March 27, 2026', // e.g. "March 15, 2026"
  STORE_NAME: 'BNP Paribas Open Shop', // e.g. "BNP Paribas Open Shop"
  CORPORATE_NAME: 'BNP Paribas Open Shop', // e.g. "Legends Global Merchandise, LLC"
  CS_EMAIL: 'customerservice@lgmretail.com', // e.g. "support@store.com" — used as mailto: href and link text
  PRIVACY_NOTICE_URL: '/pages/privacy-policy', // e.g. "/pages/privacy-notice"
  RETURNS_POLICY_URL: '/pages/cancelations-and-returns', // e.g. "/pages/shipping-returns"
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-tou-var]').forEach(function (el) {
    var key = el.getAttribute('data-tou-var');
    var val = touVars[key];
    if (!val) return; // leave fallback text/href intact if not configured
    if (el.tagName === 'A') {
      el.href = (key === 'CS_EMAIL') ? 'mailto:' + val : val;
      el.textContent = (key === 'CS_EMAIL') ? val : el.textContent;
    } else {
      el.textContent = val;
    }
  });
});

(function () {
  function openAncestorDetails(hash) {
    if (!hash) return;
    var target = document.getElementById(hash.replace(/^#/, ''));
    if (!target) return;
    var el = target.parentElement;
    while (el && el !== document.body) {
      if (el.tagName === 'DETAILS') el.open = true;
      el = el.parentElement;
    }
    requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (window.location.hash) {
    setTimeout(function () { openAncestorDetails(window.location.hash); }, 50);
  }

  window.addEventListener('hashchange', function () {
    openAncestorDetails(window.location.hash);
  });
})();